module.exports = __webpack_public_path__ + "61f4591a6be603fdddc063067a48ba6a.pdf";